import { IUserProfileResponse } from 'utils/types';

export const getUserFullName = (data: IUserProfileResponse): string =>
	`${data.lastName ? `${data.lastName} ` : ''}${data.firstName ?? ''}`;

export const fetchUserIp = (): Promise<string> =>
	fetch('https://api.ipify.org?format=json', { method: 'GET' })
		.then((response) => response.json())
		.then((data) => (data as any).ip as string);
